import SEO from "@/components/SEO";

export default function PolicyPage({ title, children, path }) {
  return (
    <div className="fade-in" data-testid={`page-${path.replace(/\//g, "")}`}>
      <SEO title={title} path={path} />
      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20 prose prose-neutral">
        <p className="eyebrow mb-4">Policy</p>
        <h1 className="text-h1 text-[#1D1D1F] !mb-6">{title}</h1>
        <div className="text-[#1D1D1F] space-y-5 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-10 [&_h2]:mb-2 [&_p]:text-[#4a4a4a] [&_p]:leading-relaxed [&_li]:text-[#4a4a4a] [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2">
          {children}
        </div>
        <p className="mt-16 text-xs text-[#86868B]">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
      </section>
    </div>
  );
}
